import React from "react";
import {TableRow} from "@mui/material";
import { defaultProps } from "recompose";
import {TableCell} from "@mui/material";
import DateHelper from "../../../../helpers/DateHelper";

const EmailBloc = ({email, ...props}) => (
    <React.Fragment>

        {
            email && <TableRow item {...props}>
                <TableCell variant="head">Adresse e-mail</TableCell>
                <TableCell> : </TableCell>
                <TableCell>{email}</TableCell>
            </TableRow>
        }
    </React.Fragment>
)


EmailBloc.withDefaultProps = defaultProps({
    email: "",
    sm: 6,
    xs: 6,
    id: ""
});


export default EmailBloc;
